import styled from 'styled-components';

const IndicatorWrapper = styled.div<{ isError: boolean }>`
  z-index: -1;
  position: relative;
  top: -24px;
  left: -24px;
  width: 100%;

  padding: 48px 24px 24px;
  ${(props) =>
    props.isError ? 'background: #f3dfdf;' : 'background: #EFF6EA;'}
`;

export default IndicatorWrapper;
